module.exports = __webpack_public_path__ + "static/media/instagram.242afcde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/instagram.svg
// module id = 253
// module chunks = 0